import { Component, OnInit } from '@angular/core';
import { AlertController, NavParams, ActionSheetController, LoadingController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import { conformToMask } from 'angular2-text-mask'

import { Company, User } from 'api/models';
// import { subscribeActiveCompany, subscribeActiveCompanyMembers, getCompany, getCompanyMembers } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
import * as permissions from '../../services/permissions';
import { AuthenticationService } from '../../services/congito';
import { HttpService } from '../../services/httpService';
import { SharedService } from '../../services/sharedService';

@Component({
  selector: 'company-users-tab',
  templateUrl: 'company-users-tab.html'
})
export class CompanyUsersTab implements OnInit {
  viewer?: Meteor.User;
  company?: Company | void;
  members?: Array<User>;
  memberCanAct:any={};
  showProfileMap: Object;

  constructor(
    private alertCtrl: AlertController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private actionSheetCtrl: ActionSheetController,
    public httpService: HttpService,
    private sharedService: SharedService,
    public companyService: CompanyService,
    public authenticationService: AuthenticationService,
  ) {
    this.showProfileMap = {};
  }
  async mainSubscription(companyId){
    this.viewer = this.authenticationService.MeteorUser();
    if (companyId) {
      this.company = this.companyService.getCompany(companyId);
      this.members = this.companyService.getCompanyMembers(this.company);
    } else {
      this.company = this.companyService.subscribeActiveCompany();
      this.members = this.companyService.subscribeActiveCompanyMembers();
    }
    this.members.forEach(member=>{
      this.memberCanAct[member._id]=this.canAct(this.company as Company, member);
    })
  }

  ngOnInit(): void {
    const companyId = this.navParams.get('companyId');
    console.log("companyId", companyId)
    this.sharedService.httpUpdate.subscribe(
      (res: any) => {
        this.mainSubscription(companyId);
      });


    MeteorObservable.autorun().subscribe(async () => {
      await this.mainSubscription(companyId);

    });
  }

  toggleMemberProfile(member: Meteor.User){
    this.showProfileMap[member._id] = !this.showProfileMap[member._id];
  }

  formatPhoneNumber(phoneNumberStr: void|string): string {
    const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return conformToMask(phoneNumberStr || '', phoneMask, {guide:false}).conformedValue;
  }

  removeCompanyMember(member): void {
    if (!this.company) {
      return;
    }

    let companyId = this.company._id;
    let userId = member._id;

    const alert = this.alertCtrl.create({
      title: 'Confirm',
      message: `Are you sure you would like to remove this user from the Company?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            /*
             MeteorObservable.call('removeCompanyMember', companyId, userId ).subscribe({
                error: (e: Error) => {
                  if (e) {
                    // this.handleError(e);
                  }
                }
              });
              */
             alert.dismiss().then(res=>{
              const loader = this.loadingCtrl.create({
                content: "Please wait...",
                enableBackdropDismiss: true,
              });
              loader.present();
              this.httpService.MeteorCall(
                'removeCompanyMember',
                companyId,
                userId
              ).then(() => {
                this.httpService.refreshSubscriptions();
                loader.dismiss()
              })
              .catch((e: Error) => {
                if (e) {
                  loader.dismiss()
                  // this.handleError(e);
                }
              });
             });


            return false;
          }
        }
      ]
    });

    alert.present();
  }

  isCompanyAdmin(company:Company, user: User) {
    return permissions.isCompanyAdmin(company, user);
  }

  makeCompanyAdmin(member: User, event): void {
    if (event) {
      event.stopPropagation();
    }
    if (!this.company) {
      return;
    }
    let companyId = this.company._id;
    let userId = member._id;
    /*
    MeteorObservable.call('makeCompanyAdmin', companyId, userId ).subscribe({
      error: (e: Error) => {
        if (e) {
          // this.handleError(e);
        }
      }
    });
    */
   const loader = this.loadingCtrl.create({
    content: "Please wait...",
    enableBackdropDismiss: true,
  });
  loader.present();
    this.httpService.MeteorCall(
      'makeCompanyAdmin',
      companyId,
      userId
    ).then(() => {
      this.httpService.refreshSubscriptions();
      loader.dismiss()
    })
    .catch((e: Error) => {
      if (e) {
        loader.dismiss()
        // this.handleError(e);
      }
    });
  }

  canAct(company:Company, member: User){
    try{
      const canMakeAdmin = this.isCompanyAdmin(company, this.viewer) && !this.isCompanyAdmin(company, member);
      const canRemoveMember = this.isCompanyAdmin(company, this.viewer);
      const canDemoteAdmin = this.isCompanyAdmin(company, this.viewer) && this.isCompanyAdmin(company, member) && this.viewer._id !== member._id;
      return canMakeAdmin || canRemoveMember || canDemoteAdmin;
    }catch(err){

    }

  }

  presentActionSheet(company:Company, member: User, event) {
    if (event) {
      event.stopPropagation();
    }

    let companyId = company._id;
    let userId = member._id;

    const canMakeAdmin = this.isCompanyAdmin(company, this.viewer) && !this.isCompanyAdmin(company, member);
    const canRemoveMember = this.isCompanyAdmin(company, this.viewer);
    const canDemoteAdmin = this.isCompanyAdmin(company, this.viewer) && this.isCompanyAdmin(company, member) && this.viewer._id !== member._id;

    let actionSheet = this.actionSheetCtrl.create({
      title: '',
      buttons: _.compact([
        canDemoteAdmin && {
          text: 'Demote Admin',
          icon: 'star-outline',
          handler: () => {
            this.demoteCompanyAdmin(member);
          }
        }, canMakeAdmin && {
          text: 'Make Admin',
          icon: 'star',
          handler: () => {
            this.makeCompanyAdmin(member, event);
          }
        }, canRemoveMember &&{
          text: 'Remove',
          icon: 'trash',
          handler: () => {
            this.removeCompanyMember(member);
          }
        },{
          text: 'Cancel',
          role: 'cancel',
          icon: 'close',
          handler: () => {
          }
        }
      ]),
    });
    actionSheet.present();
  }

  demoteCompanyAdmin(member): void {
    if (!this.company) {
      return;
    }
    let companyId = this.company._id;
    let userId = member._id;

    /*
    MeteorObservable.call('demoteCompanyAdmin', companyId, userId ).subscribe({
      error: (e: Error) => {
        if (e) {
          // this.handleError(e);
        }
      }
    });
    */
   const loader = this.loadingCtrl.create({
    content: "Please wait...",
    enableBackdropDismiss: true,
  });
  loader.present();
    this.httpService.MeteorCall(
      'demoteCompanyAdmin',
      companyId,
      userId
    ).then(() => {
      this.httpService.refreshSubscriptions();
      loader.dismiss()
    })
    .catch((e: Error) => {
      if (e) {
        loader.dismiss()
        // this.handleError(e);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/company-users-tab/company-users-tab.ts